export class QuickPaymentPropertiesResultDto {
  communityId: number;
  communityName: string;
  customerId: string;
  propertyAddress: string;
  allowOnlinePayment: boolean;
}
